import { useEffect, useState } from "react";
import styles from "./Abas.module.css";
import { FormControl, InputLabel } from "@mui/material";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import { BlueHoverButton } from "../../../../components/Inputs/BlueHoverButton";
import { columnsSolicitacaoParticipantes } from "../../Lista";
import servSolicitacaoAcesso from "../../../../services/login/servSolicitacaoAcesso";
import stylesCad from "../Cadastro.module.css";
import { TipoParticipacao } from "../../../../components/Combobox/TipoParticipacao";
import { TipoUcVinculada } from "../../../../components/Combobox/TipoUcVinculada";
import { Controller, useFormContext } from "react-hook-form";
import { HelperText } from "../../../../components/Errors/HelperText";
import ListaParticipante from "../../../../components/ListaParticipante";

const Participantes = ({
    codigoSolicitacao,
    setIsLoading,
    setOpenError,
    setTypeAlert,
    setErrorMessage,
    parecerProjeto,
    parecerViabilidade,
    situacaoSolic,
    goParticipantes,
    setParticipantes,
    onKeyDown,
    handleCadastroSolicAcesso,
    methods,
    podeSalvar
}) => {
    const [codigoUcParticipante, setcodigoUcParticipante] = useState(0);
    const [percAbatimento, setPercAbatimento] = useState(100);
    const [codigoUcExterna, setCodigoUcExterna] = useState("");
    const [inscricaoConcessionaria, setInscricaoConcessionaria] = useState("");

    const [rowsWFunction, setRowsWFunction] = useState([]);
    const { control, getValues, setValue, watch, formState: { errors } } = useFormContext();
    const [isTipoParticipacaoPorcentagem, setIsTipoParticipacaoPorcentagem] = useState(true);
    const watchTipoParticipacao = watch("TipoParticipacao");
    const [tipoParticipacaoAnterior, setTipoParticipacaoAnterior] = useState(getValues("TipoParticipacao")?.value);
    const [isUcExterna, setIsUcExterna] = useState(false);
    const watchTipoUcVinculada = watch("TipoUcVinculada");

    const editavel = (
        situacaoSolic === 1 || situacaoSolic === 4 || situacaoSolic === 5 ||
        (parecerProjeto === 2 && parecerViabilidade === 2)
    ) ? true
        : false;

    useEffect(() => {
        const verificaTipoParticipacao = async () => {
            var tipoParticipacaoAtual = getValues("TipoParticipacao")?.value;

            // 1 - Porcentagem
            // 2 - Ordem de abatimento
            if (tipoParticipacaoAtual === 1) {
                setIsTipoParticipacaoPorcentagem(true);
            } else {
                setIsTipoParticipacaoPorcentagem(false);
                setPercAbatimento(0);
            }

            // Só salva se houver modificação no campo de tipo de participação
            if ((tipoParticipacaoAtual !== tipoParticipacaoAnterior) && (!!Object.keys(methods.formState.dirtyFields).length)) {
                await handleCadastroSolicAcesso();
                await removerTodosParticipantesSolicitacao();
                setTipoParticipacaoAnterior(tipoParticipacaoAtual);
            }
        }

        verificaTipoParticipacao();
    }, [getValues("TipoParticipacao"), watchTipoParticipacao]);

    const removerTodosParticipantesSolicitacao = async () => {
        try {
            setIsLoading(true);

            await servSolicitacaoAcesso.RemoverTodosParticipantesSolicitacao(codigoSolicitacao);

            addSetToRowsData([]);
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);

            setTypeAlert("error");
            setOpenError(true);
            setErrorMessage(err?.response?.data?.Message);
        }
    }

    const normalizeInscricaoConcessionaria = (value) => {
        return (value || "")
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "")
            .slice(0, 14);
    };

    const maskInscricaoConcessionaria = (value) => {
        const rawValue = (value || "")
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "")
            .slice(0, 14);

        const parte1 = rawValue.slice(0, 2);   // alfanumérico
        const parte2 = rawValue.slice(2, 5);   // alfanumérico
        const parte3 = rawValue.slice(5, 8);   // alfanumérico
        const parte4 = rawValue.slice(8, 12);  // alfanumérico
        const parte5 = rawValue.slice(12, 14); // somente números

        let maskedValue = parte1;
        if (rawValue.length > 2) maskedValue += `.${parte2}`;
        if (rawValue.length > 5) maskedValue += `.${parte3}`;
        if (rawValue.length > 8) maskedValue += `/${parte4}`;
        if (rawValue.length > 12) maskedValue += `-${parte5.replace(/\D/g, "")}`;

        return maskedValue.slice(0, 18);
    };

    const handleSubmitParticipantes = async () => {
        try {
            const tipoUcVinculada = getValues("TipoUcVinculada")?.value;
            const inscricaoConcessionariaTratada = normalizeInscricaoConcessionaria(inscricaoConcessionaria) || " ";

            setIsLoading(true);

            if (!getValues("Id")) {
                setTypeAlert("warning");
                setOpenError(true);
                setErrorMessage("Para adicionar participantes, é necessário salvar o orçamento de conexão com informações válidas.");

                setIsLoading(false);
                return;
            }

            if (!Number.isInteger(Number(codigoUcParticipante))) {
                setIsLoading(false);

                setTypeAlert("warning");
                setOpenError(true);
                setErrorMessage("A UC não deve possuir dígitos.");
                return;
            }

            if (tipoUcVinculada === 2 && !codigoUcExterna) {
                setTypeAlert("warning");
                setOpenError(true);
                setErrorMessage("Unidade consumidora externa é obrigatória.");

                setIsLoading(false);
                return;
            }

            const response = await servSolicitacaoAcesso.InserirParticipantes({
                CodigoUC: codigoUcParticipante ? codigoUcParticipante : 0,
                PercAbatimento: percAbatimento,
                CodigoSolicitacaoAcesso: codigoSolicitacao,
                CodigoUcExterna: codigoUcExterna ? codigoUcExterna : " ",
                InscricaoConcessionaria: inscricaoConcessionariaTratada,
                TipoUcVinculada: tipoUcVinculada
            });

            let novosParticipantes = response.Content;

            novosParticipantes.map((part) => {
                part.id = part.Id;
            });

            addSetToRowsData(novosParticipantes);

            setcodigoUcParticipante("");
            isTipoParticipacaoPorcentagem ? setPercAbatimento(100) : setPercAbatimento(0);

            setIsLoading(false);

        } catch (err) {
            setIsLoading(false);

            setTypeAlert("error");
            setOpenError(true);
            setErrorMessage(err?.response?.data?.Message);
        }
    }

    const addSetToRowsData = (novosParticipantes) => {
        let rowCFuncao = novosParticipantes;

        const formattedRowsWFunction = rowCFuncao.map(element => {
            return {
                ...element,
                setParticip: setParticipantes,
                setParticipFunctions: setRowsWFunction
            }
        });

        setParticipantes(novosParticipantes);
        setRowsWFunction(formattedRowsWFunction);
    }

    const addSetToRows = () => {
        const formattedRowsWFunction = goParticipantes.map(element => {
            return {
                ...element,
                setParticip: setParticipantes,
                setParticipFunctions: setRowsWFunction
            }
        });

        setRowsWFunction(formattedRowsWFunction);
    }

    useEffect(() => {
        addSetToRows();
    }, []);

    useEffect(() => {
        verificaTipoUcVinculada();
    }, [watchTipoUcVinculada]);

    const verificaTipoUcVinculada = () => {
        const tipoUcVinculada = watchTipoUcVinculada?.value;

        if (tipoUcVinculada === 2) {
            defineCamposUcInternaDefault();
            setIsUcExterna(true);
        } else {
            defineCamposUcExternaDefault();
            setIsUcExterna(false);
        }
    }

    const defineCamposUcExternaDefault = () => {
        setValue("CodigoUcExterna", "");
        setValue("InscricaoConcessionaria", "");
        setCodigoUcExterna("");
        setInscricaoConcessionaria("");
    }

    const defineCamposUcInternaDefault = () => {
        setValue("codigoUcParticipante", 0);
        setcodigoUcParticipante(0);
    }

    const handleInscricaoConcessionariaChange = (e) => {
        const input = e.target;
        const rawValue = input.value;

        const maskedValue = maskInscricaoConcessionaria(rawValue);
        const cursorPosition = input.selectionStart ?? rawValue.length;
        const diff = maskedValue.length - rawValue.length;

        setInscricaoConcessionaria(maskedValue);

        requestAnimationFrame(() => {
            if (typeof input.setSelectionRange === "function") {
                const nextPosition = Math.max(0, cursorPosition + diff);
                input.setSelectionRange(nextPosition, nextPosition);
            }
        });
    };

    useEffect(() => {
        const tipoUcVinculada = getValues("TipoUcVinculada");

        if (!tipoUcVinculada) {
            setValue("TipoUcVinculada", { value: 1, label: "Interna" });
        }
    }, []);

    return (
        <div>
            <div style={{ padding: "30px 40px 0", display: "flex", gap: "85px" }}>
                <Controller
                    name="TipoParticipacao"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={stylesCad['campos-m']} style={{ zIndex: 2 }}>
                            <InputLabel htmlFor="solicitacao-tipoparticipacao" shrink sx={{ color: "#B8B8B8" }} >Tipo de participação </InputLabel>
                            <TipoParticipacao
                                field={field}
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                id="consulta-TipoParticipante"
                                disabled={true}
                                onKeyDown={onKeyDown}
                                placeholder="Selecione um tipo"
                                className={`${errors?.TipoParticipante ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.TipoParticipacao && (
                                <HelperText text="Este campo é obrigatório" />
                            )}
                        </FormControl>
                    )}
                />
                {isTipoParticipacaoPorcentagem && (
                    <FormControl variant="outlined" className={stylesCad['campos-m']}>
                        <InputLabel shrink htmlFor="uc-PercAbatimento" sx={{ color: "#B8B8B8" }} >% Abatimento</InputLabel>
                        <WhiteInput
                            fullWidth
                            placeholder="% Abatimento"
                            id="uc-PercAbatimento"
                            name="% Abatimento"
                            value={percAbatimento}
                            readOnly={!podeSalvar}
                            disabled={editavel}
                            onChange={(e) => setPercAbatimento(e.target.value)}
                            onKeyDown={onKeyDown}
                            type="number"
                        />
                    </FormControl>
                )}
            </div>

            <div className={styles.containerParticipantes}>
                <Controller
                    name="TipoUcVinculada"
                    control={control}
                    render={({ field }) => (
                        <FormControl
                            variant="outlined"
                            className={stylesCad['campos-m']}
                        >
                            <InputLabel
                                htmlFor="solicitacao-tipo-uc-vinculada"
                                shrink
                                sx={{ color: "#B8B8B8" }}
                            >
                                Tipo UC vinculada
                            </InputLabel>

                            <TipoUcVinculada
                                field={field}
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                id="consulta-TipoUcVinculada"
                                disabled={editavel}
                                readOnly={!podeSalvar}
                                onKeyDown={onKeyDown}
                                placeholder="Selecione um tipo"
                                className={`${errors?.TipoUcVinculada ? styles.campoComValorErrado : ""}`}
                            />

                            {errors?.TipoUcVinculada && (
                                <HelperText text="Este campo é obrigatório" />
                            )}
                        </FormControl>
                    )}
                />

                {!isUcExterna && (
                    <FormControl variant="outlined" className={stylesCad['campos-m']}>
                        <InputLabel shrink htmlFor="uc-participante" sx={{ color: "#B8B8B8" }} >Unidade consumidora* (sem dígito) </InputLabel>
                        <WhiteInput
                            fullWidth
                            placeholder="Nº da UC"
                            id="uc-participante"
                            name="Unidade consumidora"
                            value={codigoUcParticipante}
                            disabled={editavel}
                            readOnly={!podeSalvar}
                            onChange={(e) => setcodigoUcParticipante(e.target.value)}
                            onKeyDown={onKeyDown}
                            type="number"
                        />
                    </FormControl>
                )}

                {isUcExterna && (
                    <FormControl variant="outlined" className={stylesCad['campos-m']}>
                        <InputLabel shrink htmlFor="uc-externa" sx={{ color: "#B8B8B8" }} >Unidade consumidora externa </InputLabel>
                        <WhiteInput
                            fullWidth
                            placeholder="Nº da UC"
                            id="uc-externa"
                            name="Unidade consumidora externa"
                            value={codigoUcExterna}
                            disabled={editavel}
                            readOnly={!podeSalvar}
                            onChange={(e) => setCodigoUcExterna(e.target.value)}
                            onKeyDown={onKeyDown}
                            type="text"
                        />
                    </FormControl>
                )}
            </div>

            {isUcExterna && (
                <div style={{ padding: "30px 40px 10px", display: "flex", gap: "86px" }}>

                    <FormControl variant="outlined" className={stylesCad['campos-m']}>
                        <InputLabel shrink htmlFor="inscricao-concessionaria" sx={{ color: "#B8B8B8" }} >CNPJ Distribuidora recebedora </InputLabel>
                        <WhiteInput
                            fullWidth
                            placeholder="AA.AAA.AAA/AAAA-99"
                            id="inscricao-concessionaria"
                            name="CNPJ Distribuidora recebedora"
                            value={inscricaoConcessionaria}
                            disabled={editavel}
                            readOnly={!podeSalvar}
                            onChange={handleInscricaoConcessionariaChange}
                            onKeyDown={onKeyDown}
                            type="text"
                            inputProps={{ maxLength: 18 }}
                        />
                    </FormControl>
                </div>
            )}

            <div style={{ padding: "30px 40px 10px", display: "flex", gap: "86px" }}>
                <BlueHoverButton disabled={editavel} onClick={handleSubmitParticipantes}>Adicionar</BlueHoverButton>
            </div>

            <div className={styles.listaParticipantes}>
                <ListaParticipante
                    participantes={rowsWFunction}
                    isTipoParticipacaoPorcentagem={isTipoParticipacaoPorcentagem}
                    setIsLoading={setIsLoading}
                />
            </div>
        </div>
    )
}

export { Participantes }